<template>
    <div class="playBox" ref="playBox"
         :style="{ width: canvasLayerBoxW + 'px', height: canvasLayerBoxH + 'px', transform: `translate(-50%, -50%) ${scale}` }">
        <template v-if="currentFile.fileUrl">
            <img class="player" v-show="currentFile.fileType == 1"
                 :src="currentFile.fileType == 1 ? getUrl(currentFile.fileUrl) : ''"/>
            <video
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                playsinline
                webkit-inline
                webkit-playsinline
                x-webkit-airplay="allow"
                class="player"
                v-show="currentFile.fileType == 2"
                :ref="`video_${screenInfo.mediaId}`"
                muted
                :loop="false"
                preload="auto"
                :controls="false"
                autoplay
                :src="currentFile.fileType == 2 ? (currentFile.fileUrl ? getUrl(currentFile.fileUrl) : getUrl(currentFile.reduceUrl)) : 'https://static-cos.xbov.cn/www_video/bgVideo.mp4'"></video>
        </template>
        <template v-if="!!plugin.newPlugins && plugin.newPlugins.length">
            <div v-for="(item, index) in plugin.newPlugins" :key="index">
                <template v-if="item.type == 'text'">
                    <div :style="[item.newStyle, { transformOrigin: `0 0`, transform: `scale(${scale})` }]">
                        <span v-if="item.style.animationType == 0">{{ item.data.text }}</span>
                        <marquee v-if="item.style.animationType == 1" behavior="scroll"
                                 :direction="scrollDirection[item.style.direction]">{{ item.data.text }}
                        </marquee>
                        <div v-if="item.style.animationType == 2" :class="scaleDirection[item.style.direction]">
                            {{ item.data.text }}
                        </div>
                        <span v-if="item.style.animationType == 3"
                              :class="fadeoutDirection[item.style.direction]">{{ item.data.text }}</span>
                    </div>
                </template>
                <template v-if="item.type == 'time'">
                    <div :style="[item.newStyle, { transformOrigin: `0 0`, transform: `scale(${scale})` }]">
                        {{ currentTimeStap | pluginTime(item.style.displayType) }}
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import moment from 'moment';
import 'video.js/dist/video-js.css';
import Material from '../mobile/Material';
import {resourceUrl} from "@/utils/base";
import axios from "axios";

export default {
    props: {
        screenInfo: {
            type: Object,
            default: () => {}
        },
        previewContainerW: {
            type: Number,
            default: 0
        },
        previewContainerH: {
            type: Number,
            default: 0
        }
    },
    components: {
        Material,
    },
    data() {
        return {
            scrollDirection: {1: 'left', 2: 'up', 3: 'down'},
            scaleDirection: {0: 'enlarge'},
            fadeoutDirection: {1: 'fadeout'},
            canvasLayerBoxW: 0,
            canvasLayerBoxH: 0,
            canvasLayerBoxScale: 1,
            currentSpeed: 0,
            plugin: {},
            currentFile: {
                fileType: 0,
                fileUrl: '',
            },
            scale: 'scale(1,1)',
            currentTimeStap: Date.now(),
            videoPlaying: false,
        };
    },
    filters: {

        pluginTime: (timeStap, val) => {
            const week = moment(timeStap).format('d');
            const weekList = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            let srt = '';
            switch (+val) {
                case 1:
                    srt = moment(timeStap).format('YYYY年MM月DD日 HH:mm:ss');
                    break;

                case 2:
                    srt = moment(timeStap).format('YYYY年MM月DD日');
                    break;
                case 3:
                    srt = moment(timeStap).format('MM月DD日');
                    break;
                case 4:
                    srt = moment(timeStap).format('HH:mm:ss');
                    break;
                case 5:
                    srt = moment(timeStap).format('HH:mm');
                    break;
                case 6:
                    srt = moment(timeStap).format(`${weekList[week]}`);
                    break;
                case 7:
                    srt = moment(timeStap).format('YYYY年MM月DD日 HH:mm');
                    break;
                case 8:
                    srt = moment(timeStap).format(`YYYY年MM月DD日 HH:mm:ss ${weekList[week]}`);
                    break;
            }
            return srt;
        },
    },
    watch: {
        screenInfo: {
            handler(data) {
                if (data.screenId) {
                    this.getDpi(data);
                    this.getCurrentMonitorInfo(data);
                }
            },
            immediate: true,
            deep: true,
        },
        // 监听预览容器尺寸变化
        previewContainerW: {
            handler() {
                if (this.screenInfo && this.screenInfo.screenId && this.previewContainerW && this.previewContainerH) {
                    this.getDpi(this.screenInfo);
                }
            },
            immediate: true,
        },
        previewContainerH: {
            handler() {
                if (this.screenInfo && this.screenInfo.screenId && this.previewContainerW && this.previewContainerH) {
                    this.getDpi(this.screenInfo);
                }
            },
            immediate: true,
        },
        currentFile(data, dataOld) {
            if (data.fileType === 2) {
                this.$nextTick(() => {
                    const _this = this;
                    if (window.WeixinJSBridge) {
                        WeixinJSBridge.invoke('getNetworkType', {}, function () {
                            let video = _this.$refs[`video_${_this.screenInfo.mediaId}`];
                            if (video) {
                                video.currentTime = _this.currentSpeed;
                                video.play().catch(err => {
                                    console.debug('视频播放被浏览器节能策略拦截（无页面影响）：', err);
                                });
                            }
                        });
                    } else {
                        let video = _this.$refs[`video_${_this.screenInfo.mediaId}`];
                        if (video) {
                            video.currentTime = _this.currentSpeed;
                            video.play().catch(err => {
                                console.debug('视频播放被浏览器节能策略拦截（无页面影响）：', err);
                            });
                        }
                    }
                });
            }
            if (data.fileUrl !== dataOld.fileUrl) {
                this.videoPlaying = false;
            }
        },
    },
    computed: {
        imagUrl() {
            return realPictureUrl => {
                const [url] = realPictureUrl ? realPictureUrl.split(',') : [];
                return url;
            };
        },
    },
    methods: {
        getUrl(url) {
            const {resourceUrl} = require('@/utils/base');
            return url ? resourceUrl + url : '';
        },
        _canPlay(e) {
            const _this = this;
            if (window.WeixinJSBridge) {
                WeixinJSBridge.invoke('getNetworkType', {}, function () {
                    let video = _this.$refs[`video_${_this.screenInfo.mediaId}`];
                    if (video) {
                        video.currentTime = _this.currentSpeed;
                        video.play().catch(err => {
                            console.debug('视频播放被浏览器节能策略拦截（无页面影响）：', err);
                        });
                        _this.videoPlaying = true;
                    }
                });
            } else {
                document.addEventListener(
                    'WeixinJSBridgeReady',
                    function () {
                        WeixinJSBridge.invoke('getNetworkType', {}, function () {
                            let video = _this.$refs[`video_${_this.screenInfo.mediaId}`];
                            if (video && !_this.videoPlaying) {
                                video.currentTime = _this.currentSpeed;
                                video.play().catch(err => {
                                    console.debug('视频播放被浏览器节能策略拦截（无页面影响）：', err);
                                });
                                _this.videoPlaying = true;
                            }
                        });
                    },
                    false,
                );
            }
        },
        getDpi(data) {
            // 解析实际屏幕分辨率
            let canvasLayerBoxW = 1920;
            let canvasLayerBoxH = 1080;

            if (data.screenResolution) {
                const parts = data.screenResolution.split(/[*xX]/);
                if (parts.length === 2) {
                    const w = parseInt(parts[0], 10);
                    const h = parseInt(parts[1], 10);
                    if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0) {
                        canvasLayerBoxW = w;
                        canvasLayerBoxH = h;
                    }
                }
            }

            this.canvasLayerBoxW = canvasLayerBoxW;
            this.canvasLayerBoxH = canvasLayerBoxH;

            // 预览模式：直接使用传入的容器尺寸
            if (this.previewContainerW && this.previewContainerH) {
                const containerW = this.previewContainerW;
                const containerH = this.previewContainerH;

                // 计算缩放比例，让内容填满容器
                const scaleX = containerW / canvasLayerBoxW;
                const scaleY = containerH / canvasLayerBoxH;
                const scale = Math.min(scaleX, scaleY);

                this.scale = `scale(${scale})`;
                return;
            }

            // 列表模式：使用父组件的容器尺寸
            this.$nextTick(() => {
                if (canvasLayerBoxW && canvasLayerBoxH) {
                    const parentRef = this.$parent.$refs[`motScreenParent_${data.mediaId}`];
                    if (parentRef && parentRef[0]) {
                        const containerW = parentRef[0].clientWidth;
                        const containerH = parentRef[0].clientHeight;

                        // 计算缩放比例，保持内容比例适配容器
                        const scaleX = containerW / canvasLayerBoxW;
                        const scaleY = containerH / canvasLayerBoxH;
                        const scale = Math.min(scaleX, scaleY);

                        this.scale = `scale(${scale})`;
                    }
                }
            });
        },
        // 获取服务器时间
        async getServerTime() {
            try {
                const res = await axios.get(`${require('@/utils/base').baseUrl}/monitor/getServerTime`);
                if (res.data && res.data.rescode === 200 && res.data.data) {
                    return res.data.data;
                }
            } catch (e) {}
            return Date.now();
        },
        // 获取当前播放的监播数据
        async getCurrentMonitorInfo(data) {
            const monitorData = data;
            const { playType } = data;

            // 用服务器时间计算基准，确保多屏同步准确
            const serveTime = await this.getServerTime();
            let index = moment(serveTime).diff(moment(monitorData.currentDate), 'seconds');
            clearInterval(this.fileDatasTime);

            // 负 index 直接从 0 开始，不再干等
            if (index < 0) index = 0;
            // 超出范围则取模（循环播放）
            if (monitorData.dataList && index >= monitorData.dataList.length) {
                index = index % monitorData.dataList.length;
            }

            if (+playType !== 2) {
                if (!monitorData.dataList || !monitorData.dataList[index]) {
                    this.currentFile = { fileUrl: '', fileType: 0 };
                    return;
                }
                // 立即设置当前文件，视频会自动 seek 到 currentSpeed
                let currentPlan = monitorData.dataList[index];
                this.currentSpeed = currentPlan.speed;
                this.currentFile = monitorData.playListFiles[currentPlan.playIndex] || { fileUrl: '', fileType: 0 };
                this.getPlugin(monitorData.playListFiles[currentPlan.playIndex]);

                this.fileDatasTime = setInterval(() => {
                    index++;
                    if (index >= monitorData.dataList.length) return;
                    let currentPlan = monitorData.dataList[index];
                    if (!currentPlan) return;
                    this.currentSpeed = currentPlan.speed;
                    this.currentFile = monitorData.playListFiles[currentPlan.playIndex] || { fileUrl: '', fileType: 0 };
                    this.getPlugin(monitorData.playListFiles[currentPlan.playIndex]);
                }, 1000);
            } else if (+playType === 2) {
                this.fileDatasTime = setInterval(() => {
                    if (monitorData.playListFiles && monitorData.playListFiles.length) {
                        let currentPlan = monitorData.dataList[index];
                        if (!currentPlan) return;
                        let currentFile = monitorData.playListFiles[currentPlan.playIndex];
                        if (currentFile.fileUrl && currentFile.fileUrl !== this.currentFile.fileUrl) {
                            this.currentFile = currentFile;
                        }
                    } else {
                        this.currentFile = { fileType: 0, fileUrl: '' };
                    }
                }, 1000);
            }
        },
        //获取插件
        getPlugin(planPlayData) {
            let plugin = JSON.parse(planPlayData.plugins);
            if (plugin && !!plugin.plugins) {
                let newPlugins = plugin.plugins;
                plugin.newPlugins = newPlugins;
                newPlugins = newPlugins.map(item => {
                    item.newStyle = {
                        backgroundColor: item.style.backgroundColor.hex,
                        color: item.style.color.hex,
                        fontFamily: item.style.fontFamily,
                        fontSize: `${item.style.fontSize}px`,
                        fontStyle: item.style.fontStyle,
                        fontWeight: item.style.fontWeight,
                        overflow: item.style.overflow,
                        textAlign: item.style.textAlign,
                        textDecoration: item.style.textDecoration,
                        width: `${item.style.w}px`,
                        whiteSpace: item.style.whiteSpace,
                        position: 'absolute',
                        left: `${item.style.x}px`,
                        top: `${item.style.y}px`,
                        zIndex: item.style.zIndex,
                        lineHeight: 1.5,
                    };
                    return item;
                });
                this.plugin = plugin;
                let timePlugins = newPlugins.filter(v => v.type === 'time');
                if (timePlugins.length !== 0) {
                    let currentTimeStap = Date.now();
                    this.currentTimeStap = currentTimeStap;
                }
            }
        },
    },
    beforeDestroy() {
        clearInterval(this.fileDatasTime);
    },
};
</script>

<style lang="less" scoped>
.playBox {
    background-color: #000000;
    display: flex;
    align-items: center;
    top: 50%;
    left: 50%;
    justify-content: center;
    position: absolute;
    transform-origin: center center;
    .player {
        object-fit: fill;
        width: 100%;
        height: 100%;
    }

    // 放大
    .enlarge {
        animation-name: enlarge;
        animation-duration: 5s;
    }

    @keyframes enlarge {
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
    }
    // 渐出
    .fadeout {
        animation-name: fadeout;
        animation-duration: 5s;
    }

    @keyframes fadeout {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
}
</style>
